export default {
  airports: 'airports',
  availableCities: 'available-cities',
  availableCountries: 'available-countries',
  blog: 'blog',
  booking: 'bookings',
  giftCard: 'gift-cards',
  campaigns: 'campaigns',
  cities: 'cities',
  clubs: 'event/clubs',
  countries: 'countries',
  coupons: 'coupons',
  cms: 'cms',
  eventCity: 'event/events/cities',
  invoices: 'invoices',
  offers: 'offers',
  packages: 'packages',
  pages: 'pages',
  partner: 'partner',
  popularCities: 'popular-cities',
  search: 'search/typeahead',
  sportCategories: 'sport-categories',
  tournaments: 'event/tournaments',
  transit: 'transit',
  transitRoute: 'transit/transit-route',
  forms: 'forms'
}
